import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { verificarAccesoApp } from '../permisos';

// ✅ NUEVO: Función para redirigir al login con mensaje
const redirectToLoginWithMessage = (estadoSuscripcion, navigate) => {
  console.log('🔄 redirectToLoginWithMessage iniciado con estado:', estadoSuscripcion);
  
  let mensaje = '';
  
  if (estadoSuscripcion === "paused") {
    mensaje = "Tu suscripción está pausada. Contacta a soporte.";
  } else if (estadoSuscripcion === "cancelled") {
    mensaje = "Tu suscripción ha sido cancelada. Contacta a soporte.";
  } else if (estadoSuscripcion === "sin_suscripcion") {
    mensaje = "No tienes una suscripción activa. Contacta a soporte.";
  } else {
    mensaje = "Acceso restringido. Contacta a soporte.";
  }
  
  console.log('💾 Guardando mensaje en localStorage:', mensaje);
  
  // Guardar mensaje en localStorage para que el login lo lea
  localStorage.setItem('loginMessage', mensaje);
  localStorage.setItem('loginMessageType', 'error');
  
  console.log('🚀 Redirigiendo al login...');
  
  // Limpiar datos de sesión del localStorage
  localStorage.removeItem('userEmail');
  localStorage.removeItem('hoursSinceLogin');
  
  // Redirigir al login usando React Router
  navigate('/login');
  
  console.log('✅ Redirección completada');
};

/**
 * Hook para verificar acceso a la aplicación
 * Se ejecuta en cada navegación y verifica el estado de la suscripción
 */
export const useAccessControl = (usuario, constructora, onAccessDenied) => {
  const [isChecking, setIsChecking] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);
  const navigate = useNavigate();

  const checkAccess = async () => {
    if (!usuario || !constructora) {
      console.log('🔍 useAccessControl: No hay usuario o constructora');
      return;
    }
    
    console.log('🔍 useAccessControl: Verificando acceso...');
    setIsChecking(true);
    
    try {
      const accesoVerificado = await verificarAccesoApp(usuario, constructora);
      console.log('📊 useAccessControl: Resultado:', accesoVerificado);
      
      if (!accesoVerificado.puedeAcceder) {
        console.log('❌ useAccessControl: Acceso denegado, redirigiendo...');
        // Redirigir al login con mensaje personalizado
        redirectToLoginWithMessage(accesoVerificado.estadoSuscripcion, navigate);
      } else {
        console.log('✅ useAccessControl: Acceso permitido');
      }
      
      setLastCheck(new Date());
    } catch (error) {
      console.error('Error verificando acceso:', error);
    } finally {
      setIsChecking(false);
    }
  };

  // Verificar acceso cuando cambian usuario o constructora
  useEffect(() => {
    console.log('🔄 useAccessControl: useEffect usuario/constructora cambiaron');
    if (usuario && constructora) {
      console.log('🔄 useAccessControl: Ejecutando checkAccess inicial');
      checkAccess();
    }
  }, [usuario?.id, constructora?.id]);

  // Verificar acceso cada 5 minutos
  useEffect(() => {
    if (!usuario || !constructora) return;

    const interval = setInterval(() => {
      checkAccess();
    }, 5 * 60 * 1000); // 5 minutos

    return () => clearInterval(interval);
  }, [usuario?.id, constructora?.id]);

  return {
    checkAccess,
    isChecking,
    lastCheck
  };
}; 